<template>
  <div class="dashboard-container">
    <el-card class="page-header" shadow="never">
      <div class="header-content">
        <div>
          <h2>数据统计</h2>
          <p class="subtitle">实时监控系统运营数据</p>
        </div>
        <el-button type="primary" icon="el-icon-refresh" @click="loadAllData">刷新数据</el-button>
      </div>
    </el-card>

    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon user">
              <i class="el-icon-user"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">前端用户总数</div>
              <div class="stats-value">{{ statistics.totalUsers || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日新增：</span>
                <span class="trend-value increase">+{{ statistics.todayNewUsers || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon vip">
              <i class="el-icon-medal"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">会员用户数</div>
              <div class="stats-value">{{ statistics.vipUsers || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日新增：</span>
                <span class="trend-value increase">+{{ statistics.todayNewVip || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon resource">
              <i class="el-icon-folder-opened"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">资源总数</div>
              <div class="stats-value">{{ statistics.totalResources || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">待审核：</span>
                <span class="trend-value warning">{{ statistics.pendingResources || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon order">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">订单总数</div>
              <div class="stats-value">{{ statistics.totalOrders || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日订单：</span>
                <span class="trend-value increase">+{{ statistics.todayOrders || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第二行统计 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon comment">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">评论总数</div>
              <div class="stats-value">{{ statistics.totalComments || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日评论：</span>
                <span class="trend-value increase">+{{ statistics.todayComments || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon message">
              <i class="el-icon-bell"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">消息总数</div>
              <div class="stats-value">{{ statistics.totalMessages || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">未读消息：</span>
                <span class="trend-value warning">{{ statistics.unreadMessages || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon download">
              <i class="el-icon-download"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">下载总数</div>
              <div class="stats-value">{{ statistics.totalDownloads || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日下载：</span>
                <span class="trend-value increase">+{{ statistics.todayDownloads || 0 }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon revenue">
              <i class="el-icon-coin"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">总收入（元）</div>
              <div class="stats-value">{{ statistics.totalRevenue || '0.00' }}</div>
              <div class="stats-trend">
                <span class="trend-label">今日收入：</span>
                <span class="trend-value increase">+{{ statistics.todayRevenue || '0.00' }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第三行统计 - OCR使用统计(5列布局) -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="12">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon ocr-total">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">OCR总使用</div>
              <div class="stats-value">{{ statistics.ocrTotalCount || 0 }}</div>
              <div class="stats-trend">
                <span class="trend-label">温馨提醒：每类每月200次，1号自动重置</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-content">
            <div class="stats-icon ocr-mix">
              <i class="el-icon-collection"></i>
            </div>
            <div class="stats-info">
              <div class="stats-label">OCR类型使用分布</div>
              <div class="ocr-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
                <div style="display:flex;align-items:center;gap:8px;">
                  <el-tag type="success" size="small">通用文字</el-tag>
                  <el-progress :percentage="getOcrPercent(statistics.ocrGeneralCount)" :stroke-width="6" :show-text="false"></el-progress>
                  <span style="font-size:12px;color:#909399;">{{ statistics.ocrGeneralCount || 0 }}/200</span>
                </div>
                <div style="display:flex;align-items:center;gap:8px;">
                  <el-tag type="warning" size="small">全文识别高精版</el-tag>
                  <el-progress :percentage="getOcrPercent(statistics.ocrAdvancedCount)" :stroke-width="6" :show-text="false"></el-progress>
                  <span style="font-size:12px;color:#909399;">{{ statistics.ocrAdvancedCount || 0 }}/200</span>
                </div>
                <div style="display:flex;align-items:center;gap:8px;">
                  <el-tag type="danger" size="small">统一OCR识别</el-tag>
                  <el-progress :percentage="getOcrPercent(statistics.ocrDocumentCount)" :stroke-width="6" :show-text="false"></el-progress>
                  <span style="font-size:12px;color:#909399;">{{ statistics.ocrDocumentCount || 0 }}/200</span>
                </div>
                <div style="display:flex;align-items:center;gap:8px;">
                  <el-tag type="info" size="small">电商图片</el-tag>
                  <el-progress :percentage="getOcrPercent(statistics.ocrEcommerceCount)" :stroke-width="6" :show-text="false"></el-progress>
                  <span style="font-size:12px;color:#909399;">{{ statistics.ocrEcommerceCount || 0 }}/200</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>近7日用户注册趋势</span>
          </div>
          <div id="userChart" style="height: 300px;"></div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>近7日订单趋势</span>
          </div>
          <div id="orderChart" style="height: 300px;"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 最新数据 -->
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>最新注册用户</span>
          </div>
          <el-table :data="recentUsers" style="width: 100%" max-height="300">
            <el-table-column prop="username" label="用户名" width="150"></el-table-column>
            <el-table-column prop="nickname" label="昵称" width="150"></el-table-column>
            <el-table-column prop="membershipLevel" label="会员等级" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.membershipLevel === 0" type="info" size="small">普通</el-tag>
                <el-tag v-else-if="scope.row.membershipLevel === 1" type="success" size="small">黄金</el-tag>
                <el-tag v-else-if="scope.row.membershipLevel === 2" type="warning" size="small">铂金</el-tag>
                <el-tag v-else type="danger" size="small">钻石</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="注册时间">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createTime) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card shadow="hover">
          <div slot="header">
            <span>最新订单</span>
          </div>
          <el-table :data="recentOrders" style="width: 100%" max-height="300">
            <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
            <el-table-column prop="frontUserName" label="用户" width="120"></el-table-column>
            <el-table-column prop="actualPrice" label="金额" width="100">
              <template slot-scope="scope">
                ¥{{ scope.row.actualPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="paymentStatus" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.paymentStatus === 0" type="warning" size="small">待支付</el-tag>
                <el-tag v-else-if="scope.row.paymentStatus === 1" type="success" size="small">已支付</el-tag>
                <el-tag v-else type="info" size="small">已取消</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createTime) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Dashboard',
  data() {
    return {
      statistics: {},
      recentUsers: [],
      recentOrders: [],
      userChart: null,
      orderChart: null,
      loading: false
    }
  },
  mounted() {
    this.loadAllData()
  },
  activated() {
    // 当组件被激活时重新加载数据
    this.loadAllData()
  },
  beforeDestroy() {
    if (this.userChart) {
      this.userChart.dispose()
    }
    if (this.orderChart) {
      this.orderChart.dispose()
    }
  },
  methods: {
    async loadAllData() {
      await Promise.all([
        this.loadStatistics(),
        this.loadRecentUsers(),
        this.loadRecentOrders(),
        this.loadChartData()
      ])
    },

    async loadStatistics() {
      try {
        const res = await this.$axios.get('/admin/dashboard/statistics')
        if (res.data.code === 200) {
          this.statistics = res.data.data
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },

    async loadRecentUsers() {
      try {
        const res = await this.$axios.get('/admin/dashboard/recent-users')
        if (res.data.code === 200) {
          this.recentUsers = res.data.data
        }
      } catch (error) {
        console.error('加载最新用户失败:', error)
      }
    },

    async loadRecentOrders() {
      try {
        const res = await this.$axios.get('/admin/dashboard/recent-orders')
        if (res.data.code === 200) {
          this.recentOrders = res.data.data
        }
      } catch (error) {
        console.error('加载最新订单失败:', error)
      }
    },

    async loadChartData() {
      try {
        const res = await this.$axios.get('/admin/dashboard/chart-data')
        if (res.data.code === 200) {
          this.initUserChart(res.data.data.userTrend)
          this.initOrderChart(res.data.data.orderTrend)
        }
      } catch (error) {
        console.error('加载图表数据失败:', error)
      }
    },

    initUserChart(data) {
      if (this.userChart) {
        this.userChart.dispose()
      }
      this.userChart = echarts.init(document.getElementById('userChart'))
      
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: data.dates,
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        series: [{
          name: '新增用户',
          data: data.values,
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(102, 126, 234, 0.5)'
            }, {
              offset: 1,
              color: 'rgba(102, 126, 234, 0.1)'
            }])
          },
          itemStyle: {
            color: '#667eea'
          },
          lineStyle: {
            color: '#667eea',
            width: 2
          }
        }]
      }
      
      this.userChart.setOption(option)
    },

    initOrderChart(data) {
      if (this.orderChart) {
        this.orderChart.dispose()
      }
      this.orderChart = echarts.init(document.getElementById('orderChart'))
      
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: data.dates,
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        series: [{
          name: '订单数',
          data: data.values,
          type: 'bar',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#f093fb'
            }, {
              offset: 1,
              color: '#f5576c'
            }])
          }
        }]
      }
      
      this.orderChart.setOption(option)
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}`
    },

    getOcrPercent(count) {
      const c = count || 0
      return Math.min(Math.round((c / 200) * 100), 100)
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.subtitle {
  margin: 5px 0 0 0;
  color: #909399;
  font-size: 14px;
}

.stats-row {
  margin-bottom: 20px;
}

.stats-card {
  cursor: pointer;
  transition: all 0.3s;
}

.stats-card:hover {
  transform: translateY(-5px);
}

.stats-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.stats-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
}

.stats-icon.user {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stats-icon.vip {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stats-icon.resource {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.stats-icon.order {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stats-icon.comment {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.stats-icon.message {
  background: linear-gradient(135deg, #30cfd0 0%, #330867 100%);
}

.stats-icon.download {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.stats-icon.revenue {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.stats-icon.ocr-total {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.stats-icon.ocr-general {
  background: linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%);
}

.stats-icon.ocr-advanced {
  background: linear-gradient(135deg, #fddb92 0%, #d1fdff 100%);
}

.stats-icon.ocr-document {
  background: linear-gradient(135deg, #fccb90 0%, #d57eeb 100%);
}

.stats-icon.ocr-ecommerce {
  background: linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%);
}

.stats-info {
  flex: 1;
}

.stats-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stats-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.stats-trend {
  font-size: 12px;
}

.trend-label {
  color: #909399;
}

.trend-value {
  font-weight: bold;
  margin-left: 5px;
}

.trend-value.increase {
  color: #67c23a;
}

.trend-value.warning {
  color: #e6a23c;
}
</style>
